import { render, staticRenderFns } from "./AdminCreate.vue?vue&type=template&id=197596f8&scoped=true"
import script from "./AdminCreate.vue?vue&type=script&lang=js"
export * from "./AdminCreate.vue?vue&type=script&lang=js"
import style0 from "./AdminCreate.vue?vue&type=style&index=0&id=197596f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197596f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('197596f8')) {
      api.createRecord('197596f8', component.options)
    } else {
      api.reload('197596f8', component.options)
    }
    module.hot.accept("./AdminCreate.vue?vue&type=template&id=197596f8&scoped=true", function () {
      api.rerender('197596f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/admin/AdminCreate.vue"
export default component.exports